const sectionLinks = [
  { href: "#recommend", label: "番剧推荐" },
  { href: "#catalog", label: "分类浏览" },
  { href: "#movies", label: "剧场版 / OVA" },
  { href: "#region", label: "日漫与国漫" },
  { href: "#guide", label: "补番指南" },
];

const topicLinks = [
  { href: "#catalog", label: "恋爱 · 治愈" },
  { href: "#catalog", label: "热血 · 战斗" },
  { href: "#catalog", label: "仙侠 · 国漫" },
  { href: "#ranking", label: "口碑排行榜" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-primary-700">
                <i className="ri-flower-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">樱花动漫在线</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/90">
              一个把日漫、国漫、剧场版与 OVA 集中起来的动漫浏览页。我们按题材细分内容，整理番剧推荐与补番路线，让你不用来回跳转就能找到下一部想看的作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["日漫", "国漫", "剧场版", "OVA", "番剧推荐", "补番"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-background-50/10 text-background-100 text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-background-50 mb-4">站内分区</h3>
            <ul className="space-y-2.5">
              {sectionLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/90 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-background-50 mb-4">热门主题</h3>
            <ul className="space-y-2.5">
              {topicLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/90 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/80">
            © 2026 樱花动漫在线 · 本站条目为内容示例，用于展示类型细分与浏览体验。
          </p>
          <div className="flex items-center gap-2 text-xs text-background-200/80">
            <i className="ri-heart-3-line text-accent-300" aria-hidden="true"></i>
            愿每一部番都被好好看完
          </div>
        </div>
      </div>
    </footer>
  );
}